module.exports = __webpack_public_path__ + "img/federation-manager.5be79d54.svg";